export default "__VITE_ASSET__DCz8Xi1$__"